import { TASK_TIME_FORMAT } from '@/components/views/BeraJob/hooks/types/response';
import type { TaskTimeFormat } from '@/components/views/BeraJob/hooks/types/response';

const SECONDS_PRECISION = 0;
const MINUTES_PRECISION = 1;

export function toTaskTimePrecision(format: TaskTimeFormat): number {
	if (format === TASK_TIME_FORMAT.MINUTES) {
		return MINUTES_PRECISION;
	}

	return SECONDS_PRECISION;
}

export function toWholeSeconds(value: number | string): number {
	const result = Math.floor(Number(value));

	return result;
}
